import { SortingOptions, RLPSortingOptions } from '../types/SortingConst';

export const RECIPE_WISHLIST_CT_KEY = 'favorite-recipes';

export const RECIPE_WISHLIST_MAX_CHAR = 65;
export const RECIPE_WISHLIST_MAX_LIST = 5;

export const RECIPES_PER_PAGE = 18;

export const RECIPE_FILTERS_AUTHORIZED_FACETS = [
  'facet-category',
  'facet-recipeBeneficialProperties',
  'facet-recipeSpecificProblems',
  'facet-recipeAdaptedFor',
  'facet-recipeCosmeticFamilies',
  'facet-recipeDifficulty',
  'facet-recipePreparationTime',
  'facet-recipeHairTypes',
  'facet-recipeSkinTypes',
];

export const RECIPE_INGREDIENT_FACET_ID = 'facet-recipeIngredients';

export const RECIPE_ATTRAQT_SORT_MAP = {
  [SortingOptions.latest]: {
    attribute: 'ctfCreatedAt',
    order: 'desc',
  },
  [SortingOptions.alphabeticalAscending]: {
    attribute: 'title',
    order: 'asc',
  },
  [SortingOptions.alphabeticalDescending]: {
    attribute: 'title',
    order: 'desc',
  },
};

export const ADD_RECIPE_WISHLIST_DRAFT = {
  name: [
    {
      locale: 'fr',
      value: '',
    },
  ],
  custom: {
    typeKey: RECIPE_WISHLIST_CT_KEY,
  },
};
